import {
    Link, useLocation
} from "react-router-dom";

export default function Header(){
    const pathName = useLocation()?.pathname
    return(
	    <div className="header">

	    <div>
	    <Link to={'/home'}>
	    <img src='/mtuckmanlogo.svg' width="235px" height="20px"/></Link>
	    </div>
	    <div className={`${pathName === '/releases'?'orangeLink':''}`}>
	    <Link to={'/releases'}>Theatrical Releases</Link>
	    </div> 

	    <div className={`${pathName === '/booking'?'orangeLink':''}`}>
	    <Link to={'/booking'}>Theatrical Booking Services</Link>
	    </div>

	    <div  className={`${pathName === '/programming'?'orangeLink':''}`}>
	    <Link to={'/programming'}>Film Festival Programming</Link>
	    </div>

	    <div className={`${pathName === '/bio'?'orangeLink':''}`}>
	    <Link to={'/bio'}>Bio</Link>
	    </div>	    
	</div>
    )
}
